import { render, staticRenderFns } from "./supported-platforms.vue?vue&type=template&id=2485cde3&"
import script from "./supported-platforms.vue?vue&type=script&lang=js&"
export * from "./supported-platforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports